export default "__VITE_ASSET__CwJH5Hch__"